import { HStack, Text, Tag, TagLeftIcon, VStack, Badge } from '@chakra-ui/react'
import { FiMail } from 'react-icons/fi';

import { IApiTradeResponse } from '../../models/api/trade/IApiTradeResponse';

export interface IAutocompleteTradeResultProps {
    trade: IApiTradeResponse;
    onClick?(): void;
}

export const AutocompleteTradeResult = ({ trade, onClick }: IAutocompleteTradeResultProps) => (
    <VStack spacing="1" align="start">
        <Text fontWeight="medium" fontSize={{ base: "sm" }}>
            {trade.value}
        </Text>
    </VStack>
);